/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Online_Price_Clear_FailedInputs */

const vi_online_price_clear_failed = /** @type {(inputs: Online_Price_Clear_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bỏ giá Online thất bại`)
};

/**

* @param {Online_Price_Clear_FailedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const online_price_clear_failed = /** @type {((inputs?: Online_Price_Clear_FailedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Online_Price_Clear_FailedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_online_price_clear_failed(inputs)
});